module.exports = __webpack_public_path__ + "assets/img/zbh.882b9181.png";